import { render, staticRenderFns } from "./staff-brackets.vue?vue&type=template&id=3f53254b&scoped=true"
import script from "./staff-brackets.vue?vue&type=script&lang=js"
export * from "./staff-brackets.vue?vue&type=script&lang=js"
import style0 from "./staff-brackets.vue?vue&type=style&index=0&id=3f53254b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f53254b",
  null
  
)

export default component.exports